import {api} from './api';

export interface ActionLogQuery {
  page?: number;
  limit?: number;
  userId?: string;
  entityType?: string;
  actionType?: string;
  startDate?: string;
  endDate?: string;
  search?: string;
}

export const fetchActionLogs = async (params: ActionLogQuery) => {
  const { data } = await api.get('/action-log', { params });
  return data;
}; 